import "./index.css";
import { Suspense, useEffect, useState } from "react";
import { useRoutes } from "react-router-dom";
import Loader from "./components/common/loader";
import { Provider } from "react-redux";
import store from "./redux/store";
import { getRoutes } from "./routes";
import { Cookie } from "./hooks/useStorage";
import Cookies from "js-cookie";

function App() {
  const [loading, setLoading] = useState(true);
  const token = Cookies.get()?.access_token || null;
  const userRole = Cookies.get()?.ur || null;
  // Unconditionally get routes using useRoutes()
  const routeType: any = userRole !== null ? userRole : 0; // Replace with logic based on `userRole` if needed
  const router = useRoutes(getRoutes(routeType)); // ✅ Hook called regardless

  useEffect(() => {
    setTimeout(() => {
      setLoading(false); // Simulating initial check
    }, 1000);
  }, []);

  return (
    <Provider store={store}>
    {loading ? (
      <Loader />
    ) : (
      <Suspense fallback={<Loader />}>
        {router}
      </Suspense>
    )}
  </Provider>
  );
}

export default App;
